'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import pageLinkFetcherMiddleware from 'simple-menus-core/middleware/pageLinkFetcherMiddleware';
import rootReducer from 'simple-menus-lib/reducers';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function configureStore(initialState, httpClient) {
  const middleware = [thunk, pageLinkFetcherMiddleware(httpClient)];
  const createStoreWithMiddleware = composeEnhancers(applyMiddleware(thunk.withExtraArgument({
    httpClient
  })), applyMiddleware(...middleware))(createStore);
  return createStoreWithMiddleware(rootReducer, initialState);
}